import React from 'react';
import './VideoPG.scss';
import Header from './components/common-header/Header';
import contents from './contents';
import RelatedContents from './components/relatedContents/RelatedContents';

function VideoPG() {
  return (
    <main className="videoPG">
      <Header clientName={contents.header} />
      <div className="videoPG__video">
        <a href={contents.url} target="_blank" rel="sponsored">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
          >
            <path
              className="arrow__path"
              d="M0.363604 6.3636C0.0121321 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987512 7.36396 0.63604C7.01249 0.284568 6.44264 0.284568 6.09117 0.63604L0.363604 6.3636ZM2 6.1L1 6.1L1 7.9L2 7.9L2 6.1Z"
              fill="white"
            />
          </svg>
          Back to hub
        </a>
        <iframe
          src={contents.video}
          allow="fullscreen; picture-in-picture"
          className="videoPG__video__videoPlayer"
          title={contents.videoTitle}
        ></iframe>
      </div>
      <div className="videoPG__copy">
        <h1 className="videoPG__copy--title">{contents.title}</h1>
        <p className="videoPG__copy--body">{contents.copy}</p>

        <a href={contents.url} rel="sponsored" target="_blank">
          {contents.button}
        </a>
      </div>

      <RelatedContents />
    </main>
  );
}

export default VideoPG;
